import { ProtobufClient } from 'api/protobuf/protobuf-client';
import { goBackendApi } from 'hooks/api/httpApi';
import {
    EnabledShippingTypesResponse,
    EnabledShippingTypesResponseSchema,
} from '../../../pb/responses/v1/enabled_shipping_types_response_pb';

export const fetchEnabledShippingTypes = async (): Promise<EnabledShippingTypesResponse> => {
    const pbClient = new ProtobufClient(goBackendApi());
    return pbClient.getRequest(EnabledShippingTypesResponseSchema, '/api/v1/enabled-shipping-types').then((res) => res);
};
